/** Compact pagination that never overflows narrow admin screens. */
const pageNumbers = (page, lastPage) => {
  if (lastPage <= 7) return Array.from({ length: lastPage }, (_, i) => i + 1);
  const pages = new Set([1, lastPage, page - 1, page, page + 1]);
  return [...pages]
    .filter((p) => p >= 1 && p <= lastPage)
    .sort((a, b) => a - b);
};

const ExamPagination = ({ page, lastPage, onPageChange }) => {
  if (lastPage <= 0) return null;

  const pages = pageNumbers(page, lastPage);
  const buttonClass =
    "inline-flex h-9 min-w-9 items-center justify-center rounded-lg border px-2 text-xs font-semibold transition";

  return (
    <div className="flex flex-wrap items-center justify-center gap-1.5">
      <button
        type="button"
        className={`${buttonClass} border-slate-200 bg-white text-slate-600 disabled:opacity-40`}
        disabled={page === 1}
        onClick={() => onPageChange(Math.max(page - 1, 1))}
      >
        Prev
      </button>

      {pages.map((pageNumber, index) => {
        const previous = pages[index - 1];
        return (
          <span key={pageNumber} className="flex items-center gap-1.5">
            {previous && pageNumber - previous > 1 && (
              <span className="px-1 text-xs text-slate-400">…</span>
            )}
            <button
              type="button"
              className={`${buttonClass} ${
                page === pageNumber
                  ? "border-[#16213A] bg-[#16213A] text-white"
                  : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
              }`}
              onClick={() => onPageChange(pageNumber)}
            >
              {pageNumber}
            </button>
          </span>
        );
      })}

      <button
        type="button"
        className={`${buttonClass} border-slate-200 bg-white text-slate-600 disabled:opacity-40`}
        disabled={page === lastPage}
        onClick={() => onPageChange(Math.min(page + 1, lastPage))}
      >
        Next
      </button>
    </div>
  );
};

export default ExamPagination;
